import { render } from "./CajaApertura.vue?vue&type=template&id=72a1f3f4&scoped=true"
import script from "./CajaApertura.vue?vue&type=script&lang=js"
export * from "./CajaApertura.vue?vue&type=script&lang=js"

import "./CajaApertura.vue?vue&type=style&index=0&id=72a1f3f4&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\framacion_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72a1f3f4"]])

export default __exports__